import { useState, useContext, useEffect } from "react";
import { useSelector } from "react-redux";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import SoftBox from "components/SoftBox";
import SoftButton from "components/SoftButton";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { FormFieldsContext } from "layouts/Flow Designer/context";
import { form } from "../schemas/form";

const options = [
  {
    label: "Allowed Origins (CORS)",
    value: "allowedOrigins"
  },
  {
    label: "Response Body",
    value: "payloadContentType"
  },
  {
    label: "Response Code",
    value: "responseCode"
  },
  {
    label: "Response Headers",
    value: "responseHeaders"
  }
];

const AddOptionsInput = ({ allowEditWorkflow }) => {
  const formRef = useContext(FormFieldsContext);
  const { additionalOptions } = form.formField;
  const [anchorEl, setAnchorEl] = useState(null);
  const [filteredOptions, setFilteredOptions] = useState(options);
  const { currentSavedFlow } = useSelector((store) => store?.designer?.flows);
  const isFlowActive = currentSavedFlow?.shared_status === "active";

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleAddOption = (e, option) => {
    if (!allowEditWorkflow) return;
    e.stopPropagation();
    formRef?.setFieldValue(additionalOptions.name, [
      ...(formRef?.values?.additionalOptions ?? []),
      option.value
    ]);
    if (option.value === "requestHeaders" || option.value === "responseHeaders") {
      formRef?.setFieldValue(option.value, [{ key: "", value: "" }]);
    } else if (option.value === "allowedOrigins") {
      formRef?.setFieldValue(option.value, "*");
    } else if (option.value === "responseCode") {
      formRef?.setFieldValue(option.value, "200");
    }
    setAnchorEl(null);
  };

  useEffect(() => {
    setFilteredOptions(
      options.filter((o) => !formRef?.values?.additionalOptions?.includes(o.value))
    );
  }, [formRef?.values?.additionalOptions]);

  useEffect(() => {
    if (formRef?.values?.respond === "inline_code") {
      setFilteredOptions(
        options.filter(
          (option) => option.value !== "responseHeaders" && option.value !== "payloadContentType"
        )
      );

      return;
    }

    setFilteredOptions(options);
  }, [formRef?.values]);

  return (
    <SoftBox sx={{ display: "flex", justifyContent: "center", mb: "5rem"}}>
      {!isFlowActive && allowEditWorkflow && (
        <SoftButton
          variant="outlined"
          color="primary"
          sx={{ marginTop: "16px" }}
          onClick={handleClick}
          endIcon={<KeyboardArrowDownIcon />}
          disabled={isFlowActive || !allowEditWorkflow}
        >
          Add Options
        </SoftButton>
      )}
      <Menu
        id="add-options-menu"
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "top",
          horizontal: "left"
        }}
        transformOrigin={{
          vertical: "bottom",
          horizontal: "left"
        }}
      >
        {filteredOptions.map((option) => (
          <MenuItem key={option.value} onClick={(e) => handleAddOption(e, option)}>
            {option.label}
          </MenuItem>
        ))}
      </Menu>
    </SoftBox>
  );
};

export default AddOptionsInput;
